export default "__VITE_ASSET__ITNBy87t__"